import { Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';

type longAnswerProps = {};

const LongAnswer = (props: longAnswerProps) => {
  const {} = props;
  return (
    <div>
      <Form.Item
        label="Câu trả lời"
        className="md:ml-[42px] md:!w-[95.5%]"
        name={'traloiDoan'}
        wrapperCol={{ span: 14 }}
        labelCol={{ span: 2 }}
      >
        <TextArea rows={2} disabled />
      </Form.Item>
    </div>
  );
};

export default LongAnswer;
